Customer.Filters ||= {}

class Customer.Filters.DeleteFolderView extends Backbone.View
  template: JST['backbone/templates/customer/filters/delete_folder']
  events:
    'click #dont-destroy-dependent': 'destroyFolderOnly'
    'click #destroy-dependent': 'destroyFolderAndChildren'
    'click #cancel': 'close'

  initialize: ({model}) ->
    @model = model
    @modal = buttons: [], title: I18n.t('customer.dashboard.filters.folder.delete')

  render: ->
    @$el.html @template()

  destroyFolderOnly: ->
    @model.destroy
      data: JSON.stringify destroy_dependent: false
      contentType: 'application/json'
    @trigger('delete')
    @trigger('folder:deleted')
    @close()

  destroyFolderAndChildren: ->
    @model.destroy
      data: JSON.stringify destroy_dependent: true
      contentType: 'application/json'
    @trigger('delete')
    @trigger('folder:deleted')
    @close()

  close: (_triggerKeepAlive) =>
    @modalTab.destroy()
